import * as React from "react";
import { AccountResources, SwanPublicClient, StreamUpdate, Currency } from "swan-public-api-client";
import { SubscriptionLifecycle } from "../Push/SubscriptionLifecycle";
import { AppState } from "../Store/RootReducer";
import { connect } from "react-redux";

interface PropsFromState {
  groupKey: string;
  currency: Currency;
}

interface Props extends PropsFromState {
  children: (currency: Currency, clientAccountResources?: AccountResources) => JSX.Element;
}

interface State {
  clientAccountResources?: AccountResources;
}

class StreamingClientAccountResourcesCmp extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      clientAccountResources: undefined
    };
  }

  public componentDidUpdate(prevProps: Props) {
    if (prevProps.groupKey !== this.props.groupKey) {
      const state: State = {
        clientAccountResources: undefined
      };

      this.setState(state);
    }
  }

  public render() {
    const papiSubscribe = (client: SwanPublicClient, groupKey: string) => {
      return client.streamClientAccountResources(groupKey, this.consumeUpdate, undefined);
    };
    return <SubscriptionLifecycle papiSubscribe={papiSubscribe} groupKey={this.props.groupKey}>
      {() => {
        return this.props.children(this.props.currency, this.state.clientAccountResources);
      }}
    </SubscriptionLifecycle>
  }

  private consumeUpdate = (newData: Array<StreamUpdate<AccountResources>>) => {
    const data = newData[0];
    this.setState({
      clientAccountResources: data.update
    });
  }
}

const mapStateToProps = (state: AppState): PropsFromState => {
  return {
    groupKey: state.clientAccount.account!.Key,
    currency: state.clientAccount.account!.Currency
  };
};

export const StreamingClientAccountResources = connect(mapStateToProps)(StreamingClientAccountResourcesCmp);
